import ApiPage from "../pages/Api";
import CategoryList from "../pages/Category/list";
import ColorList from "../pages/Color/list";
import ProductCreate from "../pages/Product/create";
import ProductEdit from "../pages/Product/edit";
import ProductList from "../pages/Product/list";
import UserCreate from "../pages/User/create";
import UserEdit from "../pages/User/edit";
import Userlist from "../pages/User/list";

export const privateRoutes = [
    {
        path: "/user/list",
        element: <Userlist />,
        show: true,
        main: true
    },
    {
        path: "/user/edit/{id}",
        element: <UserEdit />,
        show: true,
        main: true
    },
    {
        path: "/user/create",
        element: <UserCreate />,
        show: true,
        main: true
    },
    {
        path: "/product/list",
        element: <ProductList />,
        show: true,
        main: true
    },
    {
        path: "/product/edit/:id",
        element: <ProductEdit />,
        show: true,
        main: true
    },
    {
        path: "/product/create",
        element: <ProductCreate />,
        show: true,
        main: true
    },
    {
        path: "/color/list",
        element: <ColorList />,
        show: true,
        main: true
    },
    {
        path: "/category/list",
        element: <CategoryList />,
        show: true,
        main: true
    },
    {
        path: "/api",
        element: <ApiPage />,
        show: true,
        main: true
    },
];

export const getInitialPath = () => {
    let path = null;

    for(let i = 0; i < privateRoutes.length; i++){
        if(privateRoutes[i].show && privateRoutes[i].main){
            path = privateRoutes[i].path;
            break;
        }
    }
    
    return path;
}

export default privateRoutes;